<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta</label>
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Escribe la pregunta aquí..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-row">
      <div class="q-options-header">
        <span class="q-label m-0">Campos de respuesta</span>
        <button type="button" class="q-add-btn" @click="addField">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          Agregar campo
        </button>
        <p v-if="question.fieldError" class="q-error-msg">Deben llenarse todos los campos.</p>
        <p v-if="question.minimumError" class="q-error-msg">Debe haber al menos un campo.</p>
        <p v-if="question.maximumOptionError" class="q-error-msg">Maximo {{ maxOptions }} campos.</p>
        
        <label class="q-check-row ml-auto">
          <input type="checkbox" v-model="question.obligatoria" />
          <span>Obligatoria</span>
        </label>
      </div>
    </div>
    <div class="q-row">
      <div class="q-grid">
        <div v-for="(field, index) in question.campos" :key="index" class="q-chip-item">
          <input class="q-input"
            :class="{ 'q-input--error': field.texto === '' && question.fieldError }"
            type="text" :placeholder="'Nombre del campo ' + (index + 1)"
            v-model="question.campos[index].texto" />
          <select class="q-input q-input--select" v-model="question.campos[index].tipo" style="margin-top: 4px; width: 100%;">
            <option value="texto">Texto</option>
            <option value="numero">Número</option>
            <option value="fecha">Fecha</option>
            <option value="hora">Hora</option>
          </select>
          <div v-if="question.campos[index].tipo === 'numero'" style="margin-top: 8px; display: flex; gap: 4px; flex-direction: column;">
            <label style="font-size: 0.65rem; color: #64748b;">Mínimo (opcional)</label>
            <input class="q-input" type="number" v-model.number="question.campos[index].rango_min" />
            <label style="font-size: 0.65rem; color: #64748b;">Máximo (opcional)</label>
            <input class="q-input" type="number" v-model.number="question.campos[index].rango_max" />
          </div>
          <button v-if="question.campos.length > 1" type="button" class="q-chip-del" @click="removeField(index)" title="Eliminar">×</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fields-question",
  data() { return { maxOptions: 25 }; },
  components: {},
  mounted() {
    this.fetchConfiguration();
  },
  methods: {
    remove() { this.$emit("click"); },
    addField() {
      if (this.question.campos.length < this.maxOptions) {
        this.question.campos.push({ texto: "", tipo: "texto", rango_min: null, rango_max: null });
        this.question.minimumError = false;
      } else { this.question.maximumOptionError = true; }
    },
    removeField(index) {
      if (this.question.campos.length > 1) {
        this.question.campos.splice(index, 1);
        this.question.minimumError = false; this.question.maximumOptionError = false;
      } else { this.question.minimumError = true; }
    },
    validateQuestion() {
      this.question.minimumError = false;
      return this.validateEmptyQuestion() & this.validateFields();
    },
    validateEmptyQuestion() {
      if (this.question.texto === "") { this.question.error = true; return false; }
      this.question.error = false; return true;
    },
    validateFields() {
      const empty = this.question.campos.filter(f => f.texto === "");
      if (empty.length > 0) { this.question.fieldError = true; return false; }
      this.question.fieldError = false; return true;
    },
    fetchConfiguration() {
      this.axios.get("apidev/api/config/site").then(response => {
        if (response.data && response.data.config && typeof response.data.config.max_question_options === "number") {
          this.maxOptions = response.data.config.max_question_options;
        }
      }).catch(() => {});
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 12px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #ec4899; box-shadow: 0 0 0 3px rgba(236,72,153,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #ec4899; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
.q-options-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.q-add-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #f1f5f9; color: #475569; font-size: 0.72rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.q-add-btn:hover { background: #e2e8f0; }
.q-add-btn svg { width: 12px; height: 12px; }
.q-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 8px; }
.q-chip-item { position: relative; }
.q-chip-del { position: absolute; top: -7px; right: -7px; display: flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%; background: #ef4444; color: #fff; border: none; cursor: pointer; font-size: 11px; line-height: 1; padding: 0; }
</style>
